import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.jpg';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo-mobile">
          <Link to="/" onClick={closeMenu}>
            <img src={logoImage} alt="Burbanks Logo" className="logo" />
          </Link>
        </div>
        <div className="nav-left">
          <Link to="/food-menu" className="nav-link button-style" onClick={closeMenu}>
            Food Menu
          </Link>
          <Link to="/drink-menu" className="nav-link button-style" onClick={closeMenu}>
            Drink Menu
          </Link>
          <Link to="/music" className="nav-link" onClick={closeMenu}>
            Music
          </Link>
        </div>

        <div className="nav-center">
          <Link to="/" className="nav-logo" onClick={closeMenu}>
            <img src={logoImage} alt="Burbanks Logo" className="logo" />
          </Link>
        </div>

        <div className="nav-right">
          <Link to="/billiards" className="nav-link" onClick={closeMenu}>
            Billiards
          </Link>
          <Link to="/our-story" className="nav-link" onClick={closeMenu}>
            Our Story
          </Link>
          <Link to="/private-events" className="nav-link" onClick={closeMenu}>
            Private Events
          </Link>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>
            Contact Us
          </Link>
        </div>

        <div className={`mobile-nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
          <Link to="/food-menu" className="nav-link" onClick={closeMenu}>Food Menu</Link>
          <Link to="/drink-menu" className="nav-link" onClick={closeMenu}>Drink Menu</Link>
          <Link to="/music" className="nav-link" onClick={closeMenu}>Music</Link>
          <Link to="/billiards" className="nav-link" onClick={closeMenu}>Billiards</Link>
          <Link to="/our-story" className="nav-link" onClick={closeMenu}>Our Story</Link>
          <Link to="/private-events" className="nav-link" onClick={closeMenu}>Private Events</Link>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact Us</Link>
        </div>

        <div className="nav-hamburger" onClick={toggleMenu}>
          <span className={`bar ${isMenuOpen ? 'bar-active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'bar-active' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'bar-active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 